import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CustomModal, { CustomModalActions } from '../../../../../configuracion/components/customModal';
import { GetEntryById } from '../../../../../../graphql/entries';
import EntryHistoryList from './EntryHistoryList';
import './EntryHistoryModal.scss';

const EntryHistoryModal = ({ open, onClose, entryId, entry: entryProp }) => {
  const { t } = useTranslation('accounting');
  const { selectedCompany } = useSelector((state) => state.companyList);

  const hasEditionHistory = Array.isArray(entryProp?.editionHistory);
  const shouldFetch = open && entryId && selectedCompany?.id && !hasEditionHistory;

  const { data, fetching, error } = GetEntryById({
    companyId: selectedCompany?.id,
    entryId,
    pause: !shouldFetch,
  });

  const entry = useMemo(() => {
    if (hasEditionHistory) return entryProp;
    return data?.entry || entryProp;
  }, [hasEditionHistory, entryProp, data?.entry]);

  const modalContent = useMemo(() => {
    if (fetching) {
      return <div className="entry-history-modal__loading">{t('common.loading')}</div>;
    }

    if (error) {
      return (
        <div className="entry-history-modal__error">
          {t('entryHistory.loadError')}: {error.message}
        </div>
      );
    }

    if (entry) {
      return <EntryHistoryList entry={entry} showHeader />;
    }

    return <div className="entry-history-modal__empty">{t('entryHistory.empty')}</div>;
  }, [entry, error, fetching, t]);

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title={t('entryHistory.title')}
      size="small"
      classNameModal="entry-history-modal"
      classNameContent="entry-history-modal-content-wrapper"
      scrolling
      content={modalContent}
      customActions={
        <CustomModalActions
          confirmLabel={t('entryHistory.close')}
          onConfirm={onClose}
          confirmVariant="primary"
        />
      }
    />
  );
};

export default EntryHistoryModal;
